// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import './axios'
// import store from './vuex'
import router from './router'
import { Menu, MenuItem, Row, Col } from 'element-ui'

import VueLazyload from 'vue-lazyload'

Vue.config.productionTip = false
Vue.prototype.$mediaHost = 'naranzug.ip008.com'

Vue.use(VueLazyload, {
  preLoad: 1.3, // 预压高度的比例
  error: '../assets/img/no-pic.png', // 图像的加载失败时 显示的error图标
  loading: '//' + Vue.prototype.$mediaHost + '/naranzug/wangzhan_jiegou/preloader.gif', // 图像正常加载时 显示的loading图标
  attempt: 1 // 图像尝试加载 次数
})

Vue.use(Menu)
Vue.use(MenuItem)
Vue.use(Row)
Vue.use(Col)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})

// var _hmt = _hmt || []
var _hmt = []
window._hmt = _hmt; // 必须把_hmt挂载到window下，否则找不到
(function () {
  var hm = document.createElement('script')
  hm.src = 'https://hm.baidu.com/hm.js?d4d9f77ffa77aeb1e3acb9594c033bb5'
  var s = document.getElementsByTagName('script')[0]
  s.parentNode.insertBefore(hm, s)
})()

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  if (window._hmt) {
    if (to.path) {
      window._hmt.push(['_trackPageview', '/#' + to.fullPath])
    }
  }
  next()
})



// WEBPACK FOOTER //
// ./src/main.js